/**
 * Every number is scoped: "Maritime Airborne · cash left 2026", "Your options · to date".
 * The type requires at least one " · " separator, so a bare "Cash left" does not compile.
 */
export type ScopedLabel = `${string} · ${string}`;

/** Builds a scoped label from data at runtime ("Maritime Airborne", "cash left 2026"). */
export function scoped(first: string, second: string, ...rest: readonly string[]): ScopedLabel {
  return `${first} · ${[second, ...rest].join(' · ')}`;
}
